import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { getReq, postReq, putReq, deleteReq } from './axios';
import { getBorrowerModel, borrowerBody, getDocumentsModel, getAllBorrowerModel, documentsBody, allBorrowersParams } from './models';
var BASE_URL = "".concat(apiUrl, "/borrower");
export var checkIdNumber = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(idNumber) {
    var _yield$getReq, _yield$getReq2, res, err;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getReq("".concat(BASE_URL, "/").concat(idNumber));

          case 2:
            _yield$getReq = _context.sent;
            _yield$getReq2 = _slicedToArray(_yield$getReq, 2);
            res = _yield$getReq2[0];
            err = _yield$getReq2[1];
            return _context.abrupt("return", [res && getBorrowerModel(res), err]);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function checkIdNumber(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getCkrRecords = function getCkrRecords(idNumber) {
  return getReq("".concat(BASE_URL, "/").concat(idNumber, "/check-CKR"));
};
export var createBorrower = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(body) {
    var _yield$postReq, _yield$postReq2, res, err;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return postReq(BASE_URL, borrowerBody(body));

          case 2:
            _yield$postReq = _context2.sent;
            _yield$postReq2 = _slicedToArray(_yield$postReq, 2);
            res = _yield$postReq2[0];
            err = _yield$postReq2[1];
            return _context2.abrupt("return", [res && getBorrowerModel(res), err]);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createBorrower(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var updateBorrower = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(idNumber, body) {
    var _yield$putReq, _yield$putReq2, res, err;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return putReq("".concat(BASE_URL, "/").concat(idNumber), borrowerBody(body));

          case 2:
            _yield$putReq = _context3.sent;
            _yield$putReq2 = _slicedToArray(_yield$putReq, 2);
            res = _yield$putReq2[0];
            err = _yield$putReq2[1];
            return _context3.abrupt("return", [res && getBorrowerModel(res), err]);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateBorrower(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var getAllBorrowers = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
    var _yield$getReq3, _yield$getReq4, res, err;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getReq(BASE_URL, {
              params: allBorrowersParams(params)
            });

          case 2:
            _yield$getReq3 = _context4.sent;
            _yield$getReq4 = _slicedToArray(_yield$getReq3, 2);
            res = _yield$getReq4[0];
            err = _yield$getReq4[1];
            return _context4.abrupt("return", [res && getAllBorrowerModel(res), err]);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getAllBorrowers(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var exportAllBorrowers = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(params) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", getReq("".concat(BASE_URL, "/export"), {
              params: allBorrowersParams(params),
              responseType: 'blob'
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function exportAllBorrowers(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
export var getAllBorrowersDropdown = function getAllBorrowersDropdown() {
  return getReq("".concat(BASE_URL, "/all"));
};
export var getBorrower = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
    var _yield$getReq5, _yield$getReq6, res, err;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getReq("".concat(BASE_URL, "/").concat(id));

          case 2:
            _yield$getReq5 = _context6.sent;
            _yield$getReq6 = _slicedToArray(_yield$getReq5, 2);
            res = _yield$getReq6[0];
            err = _yield$getReq6[1];
            return _context6.abrupt("return", [res && getBorrowerModel(res), err]);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getBorrower(_x7) {
    return _ref6.apply(this, arguments);
  };
}();
export var getDocumentImages = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(idNumber) {
    var _yield$getReq7, _yield$getReq8, res, err;

    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getReq("".concat(BASE_URL, "/").concat(idNumber, "/id-card-images"));

          case 2:
            _yield$getReq7 = _context7.sent;
            _yield$getReq8 = _slicedToArray(_yield$getReq7, 2);
            res = _yield$getReq8[0];
            err = _yield$getReq8[1];
            return _context7.abrupt("return", [res && getDocumentsModel(res), err]);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getDocumentImages(_x8) {
    return _ref7.apply(this, arguments);
  };
}();
export var addDocumentImages = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(idNumber, body) {
    var _yield$postReq3, _yield$postReq4, res, err;

    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return postReq("".concat(BASE_URL, "/").concat(idNumber, "/id-card-images"), documentsBody(body));

          case 2:
            _yield$postReq3 = _context8.sent;
            _yield$postReq4 = _slicedToArray(_yield$postReq3, 2);
            res = _yield$postReq4[0];
            err = _yield$postReq4[1];
            return _context8.abrupt("return", [res && getDocumentsModel(res), err]);

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function addDocumentImages(_x9, _x10) {
    return _ref8.apply(this, arguments);
  };
}();
export var addDocumentFiles = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(idNumber, formData) {
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", postReq("".concat(BASE_URL, "/").concat(idNumber, "/document"), formData));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function addDocumentFiles(_x11, _x12) {
    return _ref9.apply(this, arguments);
  };
}();
export var getDocumentFiles = function getDocumentFiles(idNumber, id) {
  return getReq("".concat(BASE_URL, "/").concat(idNumber, "/document/").concat(id), {
    responseType: 'blob'
  });
};
export var getAllBorrowerDocuments = function getAllBorrowerDocuments(idNumber) {
  return getReq("".concat(BASE_URL, "/").concat(idNumber, "/document"));
};
export var deleteBorrowerDocument = function deleteBorrowerDocument(idNumber, id) {
  return deleteReq("".concat(BASE_URL, "/").concat(idNumber, "/document/").concat(id));
};